export default __webpack_public_path__ + "static/media/Inter-Regular.26a30a5f.woff2";